import React from 'react';
import TableReport from "../../../common/table/table";
import MessageEmptyData from "../../../common/messageEmptyData";
import {isEmpty} from "lodash"
import {tableColumns} from "./tableColumns";

/**
 * Body report component for downtime report.
 * @param prop
 * @returns {JSX.Element|null}
 * @constructor
 */
const DowntimeReportBody = (prop) => {
    const {reportFilters, tableData} = prop;

    if (!reportFilters.isSubmitted) {
        return null;
    }

    if (isEmpty(tableData.rows)) {
        return <MessageEmptyData/>;
    }

    return (
        <div className="container-fluid overflow-auto">
            <TableReport
                columns={tableColumns}
                data={tableData.rows}
                exportOptions={{pdf: false, xlsx: true, csv: true}}
                getExportFileName={() => 'downtime_report'}
                scrollable={true}
            />
            <table className="table table-hover table-striped mt-5">
                <thead>
                    <tr>
                        <th>Totals Per Discipline</th>
                        <th>Hours</th>
                        <th>DT %</th>
                    </tr>
                </thead>
                <tbody>
                    { tableData.total.map((total, index) => (
                        <tr key={index}>
                            <td>{total.name}</td>
                            <td className="font-weight-bold">{total.hours}</td>
                            <td className="font-weight-bold">{total.dt_percentage} %</td>
                        </tr>
                    )) }
                </tbody>
            </table>
        </div>
    );
}

export default DowntimeReportBody;
